import type { RouteObject } from 'react-router';
import { handle } from '@/app/router/handle';

/** /account – placeholder until the account pages are built. */
export const accountRoutes: RouteObject = {
  path: 'account',
  handle: handle('home'),
  lazy: () =>
    import('@/shared/components/ComingSoonPage').then((m) => ({ Component: m.ComingSoonPage })),
};
